import angular from 'angular';
import {
  bcpDataService,
  bcpSharedModelService,
  ssDialogService,
  reportsDataService,
  orgDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editTestDocumentDialog from '../testDocuments/dialog.editTestDocumentDialog';
import controller from './edit-test-dialog.controller';
import template from './edit-test-dialog.html';
import testDateMessagesTpl from '../messages/test-date.messages.html';
import testDocuments from '../testDocuments';
import testTypeMessagesTpl from '../messages/test-type.messages.html';


class dialogService {
  getOptions($event, { assessmentId, testTypes, test }) {
    return {
      controller,
      controllerAs: 'editTestVM',
      locals: {
        assessmentId,
        testTypes,
        test
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editTestDialog', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  editTestDocumentDialog,
  testDocuments,
  ssDialogService,
  reportsDataService,
  orgDataService
])
  .service('editTestDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('test-date.messages.html', testDateMessagesTpl);
    $templateCache.put('test-type.messages.html', testTypeMessagesTpl);
  })
  .name;
